import React, { useState, useEffect, useCallback } from 'react';
import {



  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  SafeAreaView,
  StatusBar,
  FlatList,
  Modal,
  TextInput,
  Alert,
  Dimensions,
  Switch,
  ActivityIndicator,
  Image,
} from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { MaterialCommunityIcons, Ionicons } from '@expo/vector-icons';
import { useFocusEffect } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

// ===== API Configuration =====
const API_BASE_URL = 'https://api.jobeng.ai';

const getCompanyId = async () => {
  try {
    const userData = await AsyncStorage.getItem('currentUser');
    if (userData) {
      const user = JSON.parse(userData);
      return user.company_id || user.companyId || null;
    }
    const companyProfile = await AsyncStorage.getItem('companyProfile');
    if (companyProfile) {
      const company = JSON.parse(companyProfile);
      return company.id || company.company_id || null;
    }
    const bid = await AsyncStorage.getItem('company_id') || await AsyncStorage.getItem('company_id');
    if (bid) return bid;
    return null;
  } catch (e) {
    console.error('Error getting company_id:', e);
    return null;
  }
};

const apiRequest = async (endpoint, options = {}) => {
  try {
    const companyId = await getCompanyId();
    // Split endpoint and query string
    const [path, queryString] = endpoint.split('?');
    // Route: auth/* goes to /api/auth/*, everything else to /api/data/{table}
    let baseUrl;
    if (path.startsWith('auth/')) {
      baseUrl = `${API_BASE_URL}/api/${path}`;
    } else {
      // Convert hyphens to underscores for DB table mapping
      const dbPath = path.replace(/-/g, '_');
      baseUrl = `${API_BASE_URL}/api/data/${dbPath}`;
    }
    const params = new URLSearchParams(queryString || '');
    if (companyId) { params.set('company_id', companyId); params.set('company_id', companyId); }
    const separator = params.toString() ? '?' : '';
    const url = `${baseUrl}${separator}${params.toString()}`;

    const token = await AsyncStorage.getItem('auth_token') || await AsyncStorage.getItem('token');
    const headers = { 'Content-Type': 'application/json', 'X-API-Key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef' };
    if (token) headers.Authorization = 'Bearer ' + token;
    const fetchOpts = { headers, ...options };
    if (options.body) fetchOpts.body = JSON.stringify(options.body);
    const response = await fetch(url, fetchOpts);

    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`API request failed for ${endpoint}:`, error);
    throw error;
  }
};
// ===== End API Configuration =====


const { width, height } = Dimensions.get('window');

const TestsBankManagementScreen = ({ navigation, route }) => {
  
  const jobId = route?.params?.jobId || route?.params?.job_id || null;
  const jobTitle = route?.params?.jobTitle || '';
  const [companyLogo, setCompanyLogo] = useState(route?.params?.companyLogo || null);
  const [companyName, setCompanyName] = useState(route?.params?.companyName || '');
const [selectedTab, setSelectedTab] = useState('questions');
  const [testQuestions, setTestQuestions] = useState([]);
  const [testSuites, setTestSuites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [showSuiteModal, setShowSuiteModal] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [editingSuite, setEditingSuite] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedDifficulty, setSelectedDifficulty] = useState('all');

  // Question form state
  const [questionForm, setQuestionForm] = useState({
    title: '',
    question: '',
    type: 'multiple_choice',
    category: 'technical',
    difficulty: 'medium',
    timeLimit: 5,
    points: 10,
    options: ['', '', '', ''],
    correctAnswer: 0,
    explanation: '',
    tags: [],
    isActive: true,
  });

  // Suite form state
  const [suiteForm, setSuiteForm] = useState({
    name: '',
    description: '',
    category: 'technical',
    difficulty: 'medium',
    duration: 60,
    totalQuestions: 10,
    passingScore: 70,
    selectedQuestions: [],
    isActive: true,
    instructions: '',
  });

  const tabs = [
    { id: 'questions', name: 'Questions Bank', icon: 'help-circle-outline' },
    { id: 'suites', name: 'Test Suites', icon: 'folder-outline' },
    { id: 'analytics', name: 'Analytics', icon: 'chart-line' },
    { id: 'settings', name: 'Settings', icon: 'cog-outline' }
  ];

  const questionTypes = [
    { id: 'multiple_choice', name: 'Multiple Choice', icon: 'radiobox-marked' },
    { id: 'true_false', name: 'True/False', icon: 'check-circle' },
    { id: 'short_answer', name: 'Short Answer', icon: 'text-short' },
    { id: 'essay', name: 'Essay', icon: 'text-long' },
    { id: 'coding', name: 'Coding Challenge', icon: 'code-tags' },
    { id: 'file_upload', name: 'File Upload', icon: 'file-upload' }
  ];

  const categories = [
    { id: 'technical', name: 'Technical', color: '#3B82F6' },
    { id: 'aptitude', name: 'Aptitude', color: '#10B981' },
    { id: 'personality', name: 'Personality', color: '#F59E0B' },
    { id: 'behavioral', name: 'Behavioral', color: '#8B5CF6' },
    { id: 'domain', name: 'Domain Specific', color: '#EF4444' },
    { id: 'general', name: 'General Knowledge', color: '#6B7280' }
  ];

  const difficulties = [
    { id: 'easy', name: 'Easy', color: '#10B981' },
    { id: 'medium', name: 'Medium', color: '#F59E0B' },
    { id: 'hard', name: 'Hard', color: '#EF4444' },
    { id: 'expert', name: 'Expert', color: '#8B5CF6' }
  ];

  // Generate mock data
  const generateMockData = useCallback(() => {
    const mockQuestions = [];
    const mockSuites = [];

    // Generate mock questions
    for (let i = 1; i <= 50; i++) {
      const category = categories[Math.floor(Math.random() * categories.length)];
      const difficulty = difficulties[Math.floor(Math.random() * difficulties.length)];
      const type = questionTypes[Math.floor(Math.random() * questionTypes.length)];

      mockQuestions.push({
        id: `question_${i}`,
        title: `${category.name} Question ${i}`,
        question: `This is a sample ${String(type.name ?? '').toLowerCase()} question for ${String(category.name ?? '').toLowerCase()} assessment. What is the correct approach to solve this problem?`,
        type: type.id,
        category: category.id,
        difficulty: difficulty.id,
        timeLimit: Math.floor(Math.random() * 10) + 2,
        points: Math.floor(Math.random() * 20) + 5,
        options: type.id === 'multiple_choice' ? [
          'Option A - First possible answer',
          'Option B - Second possible answer', 
          'Option C - Third possible answer',
          'Option D - Fourth possible answer'
        ] : [],
        correctAnswer: type.id === 'multiple_choice' ? Math.floor(Math.random() * 4) : null,
        explanation: 'This is the explanation for why this answer is correct and provides additional context.',
        tags: [`${category.id}`, `${difficulty.id}`, 'sample'],
        isActive: Math.random() > 0.1,
        createdAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000).toISOString(),
        updatedAt: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
        usageCount: Math.floor(Math.random() * 100),
        successRate: Math.floor(Math.random() * 40) + 60,
      });
    }

    // Generate mock test suites
    for (let i = 1; i <= 15; i++) {
      const category = categories[Math.floor(Math.random() * categories.length)];
      const difficulty = difficulties[Math.floor(Math.random() * difficulties.length)];
      const questionCount = Math.floor(Math.random() * 20) + 10;
      const selectedQuestions = mockQuestions
        .filter(q => q.category === category.id)
        .slice(0, questionCount)
        .map(q => q.id);

      mockSuites.push({
        id: `suite_${i}`,
        name: `${category.name} Assessment ${i}`,
        description: `Comprehensive ${String(category.name ?? '').toLowerCase()} assessment covering key concepts and practical applications.`,
        category: category.id,
        difficulty: difficulty.id,
        duration: Math.floor(Math.random() * 60) + 30,
        totalQuestions: questionCount,
        passingScore: Math.floor(Math.random() * 20) + 60,
        selectedQuestions: selectedQuestions,
        isActive: Math.random() > 0.2,
        instructions: `This is a ${String(category.name ?? '').toLowerCase()} assessment. Please read each question carefully and select the best answer. You have limited time for each question.`,
        createdAt: new Date(Date.now() - Math.random() * 60 * 24 * 60 * 60 * 1000).toISOString(),
        updatedAt: new Date(Date.now() - Math.random() * 14 * 24 * 60 * 60 * 1000).toISOString(),
        timesUsed: Math.floor(Math.random() * 50),
        averageScore: Math.floor(Math.random() * 30) + 60,
        completionRate: Math.floor(Math.random() * 20) + 75,
      });
    }

    return { mockQuestions, mockSuites };
  }, []);

    // Company logo (same as EditSupplierScreen)
  useFocusEffect(React.useCallback(() => { loadCompanyLogo(); }, []));
  const loadCompanyLogo = async () => {
    try {
      const cachedProfile = await AsyncStorage.getItem('company_profile');
      if (cachedProfile) {
        const profile = JSON.parse(cachedProfile);
        setCompanyLogo(profile.logo || null);
        if (profile.name || profile.company_name) setCompanyName(profile.name || profile.company_name);
      }
    } catch (e) { console.warn('Logo load error:', e.message); }
  };

useEffect(() => {
    loadTestsData();
  }, []);

  const loadTestsData = async () => {
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Try API first, fall back to mock data
      let loaded = false;
      try {
        const [questionsRes, suitesRes] = await Promise.all([
          apiRequest('test-questions'),
          apiRequest('test-suites'),
        ]);
        if (questionsRes.success && questionsRes.data) {
          setTestQuestions(questionsRes.data);
          loaded = true;
        }
        if (suitesRes.success && suitesRes.data) {
          setTestSuites(suitesRes.data);
          loaded = true;
        }
      } catch (apiError) {
        console.warn('API unavailable, using mock data:', apiError.message);
      }
      if (!loaded) {
        const { mockQuestions, mockSuites } = generateMockData();
        setTestQuestions(mockQuestions);
        setTestSuites(mockSuites);
      }
    } catch (error) {
      console.error('Error loading tests data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const filteredQuestions = testQuestions.filter(question => {
    const matchesSearch = (question.title || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (question.question || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (question.tags || []).some(tag => (tag || '').toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesCategory = selectedCategory === 'all' || question.category === selectedCategory;
    const matchesDifficulty = selectedDifficulty === 'all' || question.difficulty === selectedDifficulty;
    
    return matchesSearch && matchesCategory && matchesDifficulty;
  });

  const filteredSuites = testSuites.filter(suite => {
    const matchesSearch = (suite.name || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (suite.description || '').toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || suite.category === selectedCategory;
    const matchesDifficulty = selectedDifficulty === 'all' || suite.difficulty === selectedDifficulty;
    
    return matchesSearch && matchesCategory && matchesDifficulty;
  });

  const handleCreateQuestion = () => {
    setEditingQuestion(null);
    setQuestionForm({
      title: '',
      question: '',
      type: 'multiple_choice',
      category: 'technical',
      difficulty: 'medium',
      timeLimit: 5,
      points: 10,
      options: ['', '', '', ''],
      correctAnswer: 0,
      explanation: '',
      tags: [],
      isActive: true,
    });
    setShowQuestionModal(true);
  };

  const handleEditQuestion = (question) => {
    setEditingQuestion(question);
    setQuestionForm({
      title: question.title,
      question: question.question,
      type: question.type,
      category: question.category,
      difficulty: question.difficulty,
      timeLimit: question.timeLimit,
      points: question.points,
      options: question.options || ['', '', '', ''],
      correctAnswer: question.correctAnswer || 0,
      explanation: question.explanation,
      tags: question.tags,
      isActive: question.isActive,
    });
    setShowQuestionModal(true);
  };

  const handleSaveQuestion = async () => {
    if (!questionForm.title.trim() || !questionForm.question.trim()) {
      Alert.alert('Error', 'Please fill in all required fields');
      return;
    }

    try {
      const questionData = {
        ...questionForm,
        id: editingQuestion ? editingQuestion.id : `question_${Date.now()}`,
        createdAt: editingQuestion ? editingQuestion.createdAt : new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        usageCount: editingQuestion ? editingQuestion.usageCount : 0,
        successRate: editingQuestion ? editingQuestion.successRate : 0,
      };

      // Save to API
      try {
        if (editingQuestion) {
          await apiRequest(`test-questions/${editingQuestion.id}`, { method: 'PUT', body: questionData });
        } else {
          const res = await apiRequest('test-questions', { method: 'POST', body: questionData });
          if (res?.data?.id) questionData.id = res.data.id;
        }
      } catch (e) { console.warn('API save failed:', e.message); }

      if (editingQuestion) {
        setTestQuestions(prev => prev.map(q => q.id === editingQuestion.id ? questionData : q));
      } else {
        setTestQuestions(prev => [...prev, questionData]);
      }

      setShowQuestionModal(false);
      Alert.alert('Success', `Question ${editingQuestion ? 'updated' : 'created'} successfully!`);
    } catch (error) {
      console.error('Error saving question:', error);
      Alert.alert('Error', 'Failed to save question. Please try again.');
    }
  };

  const handleCreateSuite = () => {
    setEditingSuite(null);
    setSuiteForm({
      name: '',
      description: '',
      category: 'technical',
      difficulty: 'medium',
      duration: 60,
      totalQuestions: 10,
      passingScore: 70,
      selectedQuestions: [],
      isActive: true,
      instructions: '',
    });
    setShowSuiteModal(true);
  };

  const handleEditSuite = (suite) => {
    setEditingSuite(suite);
    setSuiteForm({
      name: suite.name,
      description: suite.description,
      category: suite.category,
      difficulty: suite.difficulty,
      duration: suite.duration,
      totalQuestions: suite.totalQuestions,
      passingScore: suite.passingScore,
      selectedQuestions: suite.selectedQuestions,
      isActive: suite.isActive,
      instructions: suite.instructions,
    });
    setShowSuiteModal(true);
  };

  const handleSaveSuite = async () => {
    if (!suiteForm.name.trim() || !suiteForm.description.trim()) {
      Alert.alert('Error', 'Please fill in all required fields');
      return;
    }

    try {
      const suiteData = {
        ...suiteForm,
        id: editingSuite ? editingSuite.id : `suite_${Date.now()}`,
        createdAt: editingSuite ? editingSuite.createdAt : new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        timesUsed: editingSuite ? editingSuite.timesUsed : 0,
        averageScore: editingSuite ? editingSuite.averageScore : 0,
        completionRate: editingSuite ? editingSuite.completionRate : 0,
      };

      // Save to API
      try {
        if (editingSuite) {
          await apiRequest(`test-suites/${editingSuite.id}`, { method: 'PUT', body: suiteData });
        } else {
          const res = await apiRequest('test-suites', { method: 'POST', body: suiteData });
          if (res?.data?.id) suiteData.id = res.data.id;
        }
      } catch (e) { console.warn('API save failed:', e.message); }

      if (editingSuite) {
        setTestSuites(prev => prev.map(s => s.id === editingSuite.id ? suiteData : s));
      } else {
        setTestSuites(prev => [...prev, suiteData]);
      }

      setShowSuiteModal(false);
      Alert.alert('Success', `Test suite ${editingSuite ? 'updated' : 'created'} successfully!`);
    } catch (error) {
      console.error('Error saving suite:', error);
      Alert.alert('Error', 'Failed to save test suite. Please try again.');
    }
  };

  const handleDeleteQuestion = (question) => {
    Alert.alert(
      'Delete Question',
      `Are you sure you want to delete "${question.title}"?`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Delete',
          style: 'destructive',
          onPress: () => {
            setTestQuestions(prev => prev.filter(q => q.id !== question.id));
          }
        }
      ]
    );
  };

  const handleDeleteSuite = (suite) => {
    Alert.alert(
      'Delete Test Suite',
      `Are you sure you want to delete "${suite.name}"?`,
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Delete',
          style: 'destructive',
          onPress: () => {
            setTestSuites(prev => prev.filter(s => s.id !== suite.id));
          }
        }
      ]
    );
  };

  const getCategoryColor = (categoryId) => {
    return categories.find(c => c.id === categoryId)?.color || '#6B7280';
  };

  const getDifficultyColor = (difficultyId) => {
    return difficulties.find(d => d.id === difficultyId)?.color || '#6B7280';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  const renderQuestionCard = ({ item }) => (
    <View style={styles.questionCard}>
      <View style={styles.questionHeader}>
        <View style={styles.questionInfo}>
          <Text style={styles.questionTitle} numberOfLines={2}>{item.title}</Text>
          <Text style={styles.questionText} numberOfLines={3}>{item.question}</Text>
        </View>
        <View style={styles.questionMeta}>
          <View style={[styles.categoryBadge, { backgroundColor: getCategoryColor(item.category) }]}>
            <Text style={styles.categoryText}>
              {categories.find(c => c.id === item.category)?.name}
            </Text>
          </View>
          <View style={[styles.difficultyBadge, { backgroundColor: getDifficultyColor(item.difficulty) }]}>
            <Text style={styles.difficultyText}>
              {difficulties.find(d => d.id === item.difficulty)?.name}
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.questionDetails}>
        <View style={styles.questionDetailItem}>
          <MaterialCommunityIcons name="clock" size={16} color="#6B7280" />
          <Text style={styles.questionDetailText}>{item.timeLimit} min</Text>
        </View>
        <View style={styles.questionDetailItem}>
          <MaterialCommunityIcons name="star" size={16} color="#6B7280" />
          <Text style={styles.questionDetailText}>{item.points} pts</Text>
        </View>
        <View style={styles.questionDetailItem}>
          <MaterialCommunityIcons name="chart-line" size={16} color="#6B7280" />
          <Text style={styles.questionDetailText}>{item.successRate}% success</Text>
        </View>
        <View style={styles.questionDetailItem}>
          <MaterialCommunityIcons name="eye" size={16} color="#6B7280" />
          <Text style={styles.questionDetailText}>{item.usageCount} uses</Text>
        </View>
      </View>

      <View style={styles.questionActions}>
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => handleEditQuestion(item)}
        >
          <MaterialCommunityIcons name="pencil" size={16} color="#3B82F6" />
          <Text style={styles.actionButtonText}>Edit</Text>
        </TouchableOpacity>
        
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => handleDeleteQuestion(item)}
        >
          <MaterialCommunityIcons name="delete" size={16} color="#EF4444" />
          <Text style={[styles.actionButtonText, { color: '#EF4444' }]}>Delete</Text>
        </TouchableOpacity>
        
        <View style={styles.statusContainer}>
          <Switch
            value={item.isActive}
            onValueChange={(value) => {
              setTestQuestions(prev => prev.map(q => 
                q.id === item.id ? { ...q, isActive: value } : q
              ));
            }}
            trackColor={{ false: '#D1D5DB', true: '#10B981' }}
            thumbColor={item.isActive ? '#FFFFFF' : '#FFFFFF'}
          />
          <Text style={styles.statusText}>{item.isActive ? 'Active' : 'Inactive'}</Text>
        </View>
      </View>
    </View>
  );

  const renderSuiteCard = ({ item }) => (
    <View style={styles.suiteCard}>
      <View style={styles.suiteHeader}>
        <View style={styles.suiteInfo}>
          <Text style={styles.suiteName} numberOfLines={2}>{item.name}</Text>
          <Text style={styles.suiteDescription} numberOfLines={3}>{item.description}</Text>
        </View>
        <View style={styles.suiteMeta}>
          <View style={[styles.categoryBadge, { backgroundColor: getCategoryColor(item.category) }]}>
            <Text style={styles.categoryText}>
              {categories.find(c => c.id === item.category)?.name}
            </Text>
          </View>
          <View style={[styles.difficultyBadge, { backgroundColor: getDifficultyColor(item.difficulty) }]}>
            <Text style={styles.difficultyText}>
              {difficulties.find(d => d.id === item.difficulty)?.name}
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.suiteStats}>
        <View style={styles.suiteStatItem}>
          <MaterialCommunityIcons name="help-circle" size={20} color="#3B82F6" />
          <Text style={styles.suiteStatValue}>{item.totalQuestions}</Text>
          <Text style={styles.suiteStatLabel}>Questions</Text>
        </View>
        <View style={styles.suiteStatItem}>
          <MaterialCommunityIcons name="clock" size={20} color="#10B981" />
          <Text style={styles.suiteStatValue}>{item.duration}</Text>
          <Text style={styles.suiteStatLabel}>Minutes</Text>
        </View>
        <View style={styles.suiteStatItem}>
          <MaterialCommunityIcons name="target" size={20} color="#F59E0B" />
          <Text style={styles.suiteStatValue}>{item.passingScore}%</Text>
          <Text style={styles.suiteStatLabel}>Pass Score</Text>
        </View>
        <View style={styles.suiteStatItem}>
          <MaterialCommunityIcons name="chart-line" size={20} color="#8B5CF6" />
          <Text style={styles.suiteStatValue}>{item.averageScore}%</Text>
          <Text style={styles.suiteStatLabel}>Avg Score</Text>
        </View>
      </View>

      <View style={styles.suiteDetails}>
        <View style={styles.suiteDetailItem}>
          <MaterialCommunityIcons name="calendar" size={16} color="#6B7280" />
          <Text style={styles.suiteDetailText}>Created: {formatDate(item.createdAt)}</Text>
        </View>
        <View style={styles.suiteDetailItem}>
          <MaterialCommunityIcons name="eye" size={16} color="#6B7280" />
          <Text style={styles.suiteDetailText}>Used {item.timesUsed} times</Text>
        </View>
        <View style={styles.suiteDetailItem}>
          <MaterialCommunityIcons name="check-circle" size={16} color="#6B7280" />
          <Text style={styles.suiteDetailText}>{item.completionRate}% completion</Text>
        </View>
      </View>

      <View style={styles.suiteActions}>
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => handleEditSuite(item)}
        >
          <MaterialCommunityIcons name="pencil" size={16} color="#3B82F6" />
          <Text style={styles.actionButtonText}>Edit</Text>
        </TouchableOpacity>
        
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => handleDeleteSuite(item)}
        >
          <MaterialCommunityIcons name="delete" size={16} color="#EF4444" />
          <Text style={[styles.actionButtonText, { color: '#EF4444' }]}>Delete</Text>
        </TouchableOpacity>
        
        <TouchableOpacity
          style={styles.actionButton}
          onPress={() => {
            // Navigate to test preview or assignment
            Alert.alert('Test Suite', `Preview or assign "${item.name}" test suite`);
          }}
        >
          <MaterialCommunityIcons name="play" size={16} color="#10B981" />
          <Text style={[styles.actionButtonText, { color: '#10B981' }]}>Use</Text>
        </TouchableOpacity>
        
        <View style={styles.statusContainer}>
          <Switch
            value={item.isActive}
            onValueChange={(value) => {
              setTestSuites(prev => prev.map(s => 
                s.id === item.id ? { ...s, isActive: value } : s
              ));
            }}
            trackColor={{ false: '#D1D5DB', true: '#10B981' }}
            thumbColor={item.isActive ? '#FFFFFF' : '#FFFFFF'}
          />
          <Text style={styles.statusText}>{item.isActive ? 'Active' : 'Inactive'}</Text>
        </View>
      </View>
    </View>
  );

  const renderAnalytics = () => (
    <ScrollView style={styles.analyticsContainer}>
      <View style={styles.analyticsGrid}>
        <View style={styles.analyticsCard}>
          <MaterialCommunityIcons name="help-circle" size={32} color="#3B82F6" />
          <Text style={styles.analyticsValue}>{testQuestions.length}</Text>
          <Text style={styles.analyticsLabel}>Total Questions</Text>
        </View>
        
        <View style={styles.analyticsCard}>
          <MaterialCommunityIcons name="folder" size={32} color="#10B981" />
          <Text style={styles.analyticsValue}>{testSuites.length}</Text>
          <Text style={styles.analyticsLabel}>Test Suites</Text>
        </View>
        
        <View style={styles.analyticsCard}>
          <MaterialCommunityIcons name="check-circle" size={32} color="#F59E0B" />
          <Text style={styles.analyticsValue}>
            {testQuestions.filter(q => q.isActive).length}
          </Text>
          <Text style={styles.analyticsLabel}>Active Questions</Text>
        </View>
        
        <View style={styles.analyticsCard}>
          <MaterialCommunityIcons name="chart-line" size={32} color="#8B5CF6" />
          <Text style={styles.analyticsValue}>
            {Math.round(testQuestions.reduce((acc, q) => acc + q.successRate, 0) / testQuestions.length || 0)}%
          </Text>
          <Text style={styles.analyticsLabel}>Avg Success Rate</Text>
        </View>
      </View>

      <View style={styles.categoryBreakdown}>
        <Text style={styles.sectionTitle}>Questions by Category</Text>
        {categories.map(category => {
          const count = testQuestions.filter(q => q.category === category.id).length;
          const percentage = testQuestions.length > 0 ? (count / testQuestions.length) * 100 : 0;
          
          return (
            <View key={category.id} style={styles.categoryBreakdownItem}>
              <View style={styles.categoryBreakdownInfo}>
                <View style={[styles.categoryDot, { backgroundColor: category.color }]} />
                <Text style={styles.categoryBreakdownName}>{category.name}</Text>
              </View>
              <View style={styles.categoryBreakdownStats}>
                <Text style={styles.categoryBreakdownCount}>{count}</Text>
                <Text style={styles.categoryBreakdownPercentage}>({percentage.toFixed(1)}%)</Text>
              </View>
            </View>
          );
        })}
      </View>

      <View style={styles.difficultyBreakdown}>
        <Text style={styles.sectionTitle}>Questions by Difficulty</Text>
        {difficulties.map(difficulty => {
          const count = testQuestions.filter(q => q.difficulty === difficulty.id).length;
          const percentage = testQuestions.length > 0 ? (count / testQuestions.length) * 100 : 0;
          
          return (
            <View key={difficulty.id} style={styles.difficultyBreakdownItem}>
              <View style={styles.difficultyBreakdownInfo}>
                <View style={[styles.difficultyDot, { backgroundColor: difficulty.color }]} />
                <Text style={styles.difficultyBreakdownName}>{difficulty.name}</Text>
              </View>
              <View style={styles.difficultyBreakdownStats}>
                <Text style={styles.difficultyBreakdownCount}>{count}</Text>
                <Text style={styles.difficultyBreakdownPercentage}>({percentage.toFixed(1)}%)</Text>
              </View>
            </View>
          );
        })}
      </View>
    </ScrollView>
  );

  const renderSettings = () => (
    <ScrollView style={styles.settingsContainer}>
      <View style={styles.settingsSection}>
        <Text style={styles.settingsSectionTitle}>General Settings</Text>
        
        <View style={styles.settingsItem}>
          <View style={styles.settingsItemInfo}>
            <Text style={styles.settingsItemTitle}>Auto-save drafts</Text>
            <Text style={styles.settingsItemDescription}>Automatically save question drafts</Text>
          </View>
          <Switch
            value={true}
            trackColor={{ false: '#D1D5DB', true: '#10B981' }}
            thumbColor="#FFFFFF"
          />
        </View>
        
        <View style={styles.settingsItem}>
          <View style={styles.settingsItemInfo}>
            <Text style={styles.settingsItemTitle}>Question validation</Text>
            <Text style={styles.settingsItemDescription}>Validate questions before saving</Text>
          </View>
          <Switch
            value={true}
            trackColor={{ false: '#D1D5DB', true: '#10B981' }}
            thumbColor="#FFFFFF"
          />
        </View>
      </View>

      <View style={styles.settingsSection}>
        <Text style={styles.settingsSectionTitle}>Import/Export</Text>
        
        <TouchableOpacity style={styles.settingsButton}>
          <MaterialCommunityIcons name="upload" size={24} color="#3B82F6" />
          <Text style={styles.settingsButtonText}>Import Questions</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.settingsButton}>
          <MaterialCommunityIcons name="download" size={24} color="#10B981" />
          <Text style={styles.settingsButtonText}>Export Questions</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.settingsButton}>
          <MaterialCommunityIcons name="backup-restore" size={24} color="#F59E0B" />
          <Text style={styles.settingsButtonText}>Backup Data</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.settingsSection}>
        <Text style={styles.settingsSectionTitle}>Advanced</Text>
        
        <TouchableOpacity style={styles.settingsButton}>
          <MaterialCommunityIcons name="database" size={24} color="#8B5CF6" />
          <Text style={styles.settingsButtonText}>Database Management</Text>
        </TouchableOpacity>
        
        <TouchableOpacity style={styles.settingsButton}>
          <MaterialCommunityIcons name="chart-bar" size={24} color="#EF4444" />
          <Text style={styles.settingsButtonText}>Advanced Analytics</Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );

  const renderQuestionModal = () => (
    <Modal visible={showQuestionModal} transparent animationType="slide">
      <View style={styles.modalOverlay}>
        <View style={styles.questionModal}>
          <View style={styles.modalHeader}>
            <Text style={styles.modalTitle}>
              <Text>{editingQuestion ? 'Edit Question' : 'Create Question'}</Text>
            </Text>
            <TouchableOpacity onPress={() => setShowQuestionModal(false)}>
              <Ionicons name="close" size={24} color="#333" />
            </TouchableOpacity>
          </View>
          
          <ScrollView style={styles.modalContent}>
            <View style={styles.formGroup}>
              <Text style={styles.formLabel}>Question Title *</Text>
              <TextInput
                style={styles.formInput}
                value={questionForm.title}
                onChangeText={(text) => setQuestionForm(prev => ({ ...prev, title: text }))}
                placeholder="Enter question title"
              />
            </View>

            <View style={styles.formGroup}>
              <Text style={styles.formLabel}>Question Text *</Text>
              <TextInput
                style={[styles.formInput, styles.textArea]}
                value={questionForm.question}
                onChangeText={(text) => setQuestionForm(prev => ({ ...prev, question: text }))}
                placeholder="Enter the question"
                multiline
                numberOfLines={4}
                textAlignVertical="top"
              />
            </View>

            <View style={styles.formRow}>
              <View style={styles.formGroupHalf}>
                <Text style={styles.formLabel}>Type</Text>
                <View style={styles.pickerContainer}>
                  {questionTypes.map(type => (
                    <TouchableOpacity
                      key={type.id}
                      style={[
                        styles.pickerOption,
                        questionForm.type === type.id && styles.pickerOptionSelected
                      ]}
                      onPress={() => setQuestionForm(prev => ({ ...prev, type: type.id }))}
                    >
                      <MaterialCommunityIcons 
                        name={type.icon} 
                        size={16} 
                        color={questionForm.type === type.id ? '#8B5CF6' : '#6B7280'} 
                      />
                      <Text style={[
                        styles.pickerOptionText,
                        questionForm.type === type.id && styles.pickerOptionTextSelected
                      ]}>
                        {type.name}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </View>

              <View style={styles.formGroupHalf}>
                <Text style={styles.formLabel}>Category</Text>
                <View style={styles.pickerContainer}>
                  {categories.map(category => (
                    <TouchableOpacity
                      key={category.id}
                      style={[
                        styles.pickerOption,
                        questionForm.category === category.id && styles.pickerOptionSelected
                      ]}
                      onPress={() => setQuestionForm(prev => ({ ...prev, category: category.id }))}
                    >
                      <View style={[styles.categoryDot, { backgroundColor: category.color }]} />
                      <Text style={[
                        styles.pickerOptionText,
                        questionForm.category === category.id && styles.pickerOptionTextSelected
                      ]}>
                        {category.name}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </View>
            </View>

            {questionForm.type === 'multiple_choice' && (
              <View style={styles.formGroup}>
                <Text style={styles.formLabel}>Answer Options</Text>
                {questionForm.options.map((option, index) => (
                  <View key={index} style={styles.optionContainer}>
                    <TouchableOpacity
                      style={[
                        styles.optionRadio,
                        questionForm.correctAnswer === index && styles.optionRadioSelected
                      ]}
                      onPress={() => setQuestionForm(prev => ({ ...prev, correctAnswer: index }))}
                    >
                      {questionForm.correctAnswer === index && (
                        <MaterialCommunityIcons name="check" size={12} color="#FFFFFF" />
                      )}
                    </TouchableOpacity>
                    <TextInput
                      style={styles.optionInput}
                      value={option}
                      onChangeText={(text) => {
                        const newOptions = [...questionForm.options];
                        newOptions[index] = text;
                        setQuestionForm(prev => ({ ...prev, options: newOptions }));
                      }}
                      placeholder={`Option ${String.fromCharCode(65 + index)}`}
                    />
                  </View>
                ))}
              </View>
            )}

            <View style={styles.formGroup}>
              <Text style={styles.formLabel}>Explanation</Text>
              <TextInput
                style={[styles.formInput, styles.textArea]}
                value={questionForm.explanation}
                onChangeText={(text) => setQuestionForm(prev => ({ ...prev, explanation: text }))}
                placeholder="Explain why this is the correct answer"
                multiline
                numberOfLines={3}
                textAlignVertical="top"
              />
            </View>

            <View style={styles.formRow}>
              <View style={styles.formGroupThird}>
                <Text style={styles.formLabel}>Difficulty</Text>
                <View style={styles.pickerContainer}>
                  {difficulties.map(difficulty => (
                    <TouchableOpacity
                      key={difficulty.id}
                      style={[
                        styles.pickerOption,
                        questionForm.difficulty === difficulty.id && styles.pickerOptionSelected
                      ]}
                      onPress={() => setQuestionForm(prev => ({ ...prev, difficulty: difficulty.id }))}
                    >
                      <View style={[styles.difficultyDot, { backgroundColor: difficulty.color }]} />
                      <Text style={[
                        styles.pickerOptionText,
                        questionForm.difficulty === difficulty.id && styles.pickerOptionTextSelected
                      ]}>
                        {difficulty.name}
                      </Text>
                    </TouchableOpacity>
                  ))}
                </View>
              </View>

              <View style={styles.formGroupThird}>
                <Text style={styles.formLabel}>Time Limit (min)</Text>
                <TextInput
                  style={styles.formInput}
                  value={questionForm.timeLimit.toString()}
                  onChangeText={(text) => setQuestionForm(prev => ({ 
                    ...prev, 
                    timeLimit: parseInt(text) || 0 
                  }))}
                  keyboardType="numeric"
                  placeholder="5"
                />
              </View>

              <View style={styles.formGroupThird}>
                <Text style={styles.formLabel}>Points</Text>
                <TextInput
                  style={styles.formInput}
                  value={questionForm.points.toString()}
                  onChangeText={(text) => setQuestionForm(prev => ({ 
                    ...prev, 
                    points: parseInt(text) || 0 
                  }))}
                  keyboardType="numeric"
                  placeholder="10"
                />
              </View>
            </View>

            <View style={styles.formGroup}>
              <View style={styles.switchContainer}>
                <Text style={styles.switchLabel}>Active Question</Text>
                <Switch
                  value={questionForm.isActive}
                  onValueChange={(value) => setQuestionForm(prev => ({ ...prev, isActive: value }))}
                  trackColor={{ false: '#D1D5DB', true: '#10B981' }}
                  thumbColor="#FFFFFF"
                />
              </View>
            </View>
          </ScrollView>
          
          <View style={styles.modalFooter}>
            <TouchableOpacity
              style={styles.modalCancelButton}
              onPress={() => setShowQuestionModal(false)}
            >
              <Text style={styles.modalCancelButtonText}>Cancel</Text>
            </TouchableOpacity>
            
            <TouchableOpacity
              style={styles.modalSaveButton}
              onPress={handleSaveQuestion}
            >
              <MaterialCommunityIcons name="content-save" size={20} color="#FFFFFF" />
              <Text style={styles.modalSaveButtonText}>
                <Text>{editingQuestion ? 'Update' : 'Create'} Question</Text>
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );

  if (isLoading) {
    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.loadingContainer}>
          <ActivityIndicator size={36} color="#8B5CF6" />
          <Text style={styles.loadingText}>Loading tests bank...</Text>
        </View>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#8B5CF6" />
      
      {/* Header */}
      <LinearGradient colors={['#8B5CF6', '#7C3AED']} style={styles.header}>
        <View style={styles.headerContent}>
          <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
            <MaterialCommunityIcons name="arrow-left" size={24} color="#FFFFFF" />
          </TouchableOpacity>
          
          <View style={styles.headerInfo}>
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              {companyLogo ? (
                <Image source={{ uri: companyLogo || undefined }} style={{ width: 24, height: 24, borderRadius: 12, marginRight: 8 }} />
              ) : (
                <MaterialCommunityIcons name="office-building" size={20} color="#fff" style={{ marginRight: 8 }} />
              )}
              <Text style={styles.headerTitle}>Tests Bank</Text>
            </View>
            {jobTitle ? <Text style={{ color: 'rgba(255,255,255,0.7)', fontSize: 11 }}>{jobTitle}</Text> : null}
            <Text style={styles.headerSubtitle}>
              {testQuestions.length} Questions • {testSuites.length} Suites
            </Text>
          </View>
          
          <TouchableOpacity 
            style={styles.addButton}
            onPress={selectedTab === 'questions' ? handleCreateQuestion : handleCreateSuite}
          >
            <MaterialCommunityIcons name="plus" size={24} color="#FFFFFF" />
          </TouchableOpacity>
        </View>
      </LinearGradient>
      {/* Cross Navigation */}
      <View style={{ backgroundColor: '#FFF', borderBottomWidth: 1, borderBottomColor: '#E5E7EB' }}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{ paddingHorizontal: 12, paddingVertical: 8 }}>
          {jobTitle ? <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#0e4e9615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.goBack()}>
            <MaterialCommunityIcons name="briefcase" size={14} color="#0e4e96" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#0e4e96', marginLeft: 4 }}>Job Details</Text>
          </TouchableOpacity> : null}
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#8B5CF615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestApplicantsScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="clipboard-check" size={14} color="#8B5CF6" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#8B5CF6', marginLeft: 4 }}>Test Applicants</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#3B82F615', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestCandidatesPipelineScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="account-clock" size={14} color="#3B82F6" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#3B82F6', marginLeft: 4 }}>Candidates Pipeline</Text>
          </TouchableOpacity>
          <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', backgroundColor: '#10B98115', paddingHorizontal: 12, paddingVertical: 6, borderRadius: 16, marginRight: 8 }} onPress={() => navigation.navigate('TestResultsScreen', { jobId, jobTitle, companyLogo, companyName })}>
            <MaterialCommunityIcons name="chart-box" size={14} color="#10B981" />
            <Text style={{ fontSize: 12, fontWeight: '600', color: '#10B981', marginLeft: 4 }}>Test Results</Text>
          </TouchableOpacity>
        </ScrollView>
      </View>


      {/* Tabs */}
      <View style={styles.tabsContainer}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.tabsContent}>
          {tabs.map((tab) => (
            <TouchableOpacity
              key={tab.id}
              style={[styles.tab, selectedTab === tab.id && styles.activeTab]}
              onPress={() => setSelectedTab(tab.id)}
            >
              <MaterialCommunityIcons
                name={tab.icon}
                size={20}
                color={selectedTab === tab.id ? '#8B5CF6' : '#6B7280'}
              />
              <Text style={[styles.tabText, selectedTab === tab.id && styles.activeTabText]}>
                {tab.name}
              </Text>
            </TouchableOpacity>
          ))}
        </ScrollView>
      </View>

      {/* Search and Filters */}
      {(selectedTab === 'questions' || selectedTab === 'suites') && (
        <View style={styles.filtersContainer}>
          <View style={styles.searchContainer}>
            <MaterialCommunityIcons name="magnify" size={20} color="#6B7280" />
            <TextInput
              style={styles.searchInput}
              value={searchQuery}
              onChangeText={setSearchQuery}
              placeholder="Search questions or suites..."
            />
          </View>
          
          <ScrollView horizontal showsHorizontalScrollIndicator={false} style={styles.filterTags}>
            <TouchableOpacity
              style={[styles.filterTag, selectedCategory === 'all' && styles.activeFilterTag]}
              onPress={() => setSelectedCategory('all')}
            >
              <Text style={[styles.filterTagText, selectedCategory === 'all' && styles.activeFilterTagText]}>
                All Categories
              </Text>
            </TouchableOpacity>
            
            {categories.map(category => (
              <TouchableOpacity
                key={category.id}
                style={[styles.filterTag, selectedCategory === category.id && styles.activeFilterTag]}
                onPress={() => setSelectedCategory(category.id)}
              >
                <View style={[styles.categoryDot, { backgroundColor: category.color }]} />
                <Text style={[styles.filterTagText, selectedCategory === category.id && styles.activeFilterTagText]}>
                  {category.name}
                </Text>
              </TouchableOpacity>
            ))}
          </ScrollView>
        </View>
      )}

      {/* Content */}
      <View style={styles.content}>
        {selectedTab === 'questions' && (
          <FlatList
            data={filteredQuestions}
            keyExtractor={(item) => item.id}
            renderItem={renderQuestionCard}
            style={styles.questionsList}
            contentContainerStyle={styles.questionsListContent}
            showsVerticalScrollIndicator={false}
            ListEmptyComponent={() => (
              <View style={styles.emptyContainer}>
                <MaterialCommunityIcons name="help-circle-outline" size={64} color="#D1D5DB" />
                <Text style={styles.emptyTitle}>No questions found</Text>
                <Text style={styles.emptySubtitle}>
                  <Text>{searchQuery ? 'Try adjusting your search criteria' : 'Create your first question to get started'}</Text>
                </Text>
              </View>
            )}
          />
        )}

        {selectedTab === 'suites' && (
          <FlatList
            data={filteredSuites}
            keyExtractor={(item) => item.id}
            renderItem={renderSuiteCard}
            style={styles.suitesList}
            contentContainerStyle={styles.suitesListContent}
            showsVerticalScrollIndicator={false}
            ListEmptyComponent={() => (
              <View style={styles.emptyContainer}>
                <MaterialCommunityIcons name="folder-outline" size={64} color="#D1D5DB" />
                <Text style={styles.emptyTitle}>No test suites found</Text>
                <Text style={styles.emptySubtitle}>
                  <Text>{searchQuery ? 'Try adjusting your search criteria' : 'Create your first test suite to get started'}</Text>
                </Text>
              </View>
            )}
          />
        )}

        {selectedTab === 'analytics' && renderAnalytics()}
        {selectedTab === 'settings' && renderSettings()}
      </View>

      {/* Modals */}
      {renderQuestionModal()}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9FAFB',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#6B7280',
  },
  header: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerInfo: {
    flex: 1,
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  headerSubtitle: {
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.8)',
    marginTop: 4,
  },
  addButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabsContainer: {
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  tabsContent: {
    paddingHorizontal: 20,
  },
  tab: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginRight: 8,
    borderRadius: 20,
    backgroundColor: '#F3F4F6',
  },
  activeTab: {
    backgroundColor: '#F3E8FF',
  },
  tabText: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: '500',
    color: '#6B7280',
  },
  activeTabText: {
    color: '#8B5CF6',
  },
  filtersContainer: {
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 12,
  },
  searchInput: {
    flex: 1,
    marginLeft: 8,
    fontSize: 16,
    color: '#1F2937',
  },
  filterTags: {
    flexDirection: 'row',
  },
  filterTag: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: '#F3F4F6',
    borderRadius: 16,
    marginRight: 8,
  },
  activeFilterTag: {
    backgroundColor: '#8B5CF6',
  },
  filterTagText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#6B7280',
  },
  activeFilterTagText: {
    color: '#FFFFFF',
  },
  content: {
    flex: 1,
  },
  questionsList: {
    flex: 1,
  },
  questionsListContent: {
    padding: 20,
  },
  questionCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  questionHeader: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  questionInfo: {
    flex: 1,
    marginRight: 12,
  },
  questionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 4,
  },
  questionText: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20,
  },
  questionMeta: {
    alignItems: 'flex-end',
  },
  categoryBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    marginBottom: 4,
  },
  categoryText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  difficultyBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  difficultyText: {
    fontSize: 10,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  questionDetails: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
    paddingVertical: 8,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  questionDetailItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  questionDetailText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
  },
  questionActions: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  actionButtonText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#3B82F6',
    fontWeight: '500',
  },
  statusContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusText: {
    marginLeft: 8,
    fontSize: 12,
    color: '#6B7280',
  },
  suitesList: {
    flex: 1,
  },
  suitesListContent: {
    padding: 20,
  },
  suiteCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  suiteHeader: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  suiteInfo: {
    flex: 1,
    marginRight: 12,
  },
  suiteName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1F2937',
    marginBottom: 4,
  },
  suiteDescription: {
    fontSize: 14,
    color: '#6B7280',
    lineHeight: 20,
  },
  suiteMeta: {
    alignItems: 'flex-end',
  },
  suiteStats: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  suiteStatItem: {
    alignItems: 'center',
    flex: 1,
  },
  suiteStatValue: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1F2937',
    marginTop: 4,
  },
  suiteStatLabel: {
    fontSize: 12,
    color: '#6B7280',
    marginTop: 2,
  },
  suiteDetails: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
    paddingVertical: 8,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    paddingHorizontal: 12,
  },
  suiteDetailItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  suiteDetailText: {
    marginLeft: 4,
    fontSize: 12,
    color: '#6B7280',
  },
  suiteActions: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  analyticsContainer: {
    flex: 1,
    padding: 20,
  },
  analyticsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  analyticsCard: {
    width: '48%',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    alignItems: 'center',
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  analyticsValue: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#1F2937',
    marginTop: 8,
  },
  analyticsLabel: {
    fontSize: 14,
    color: '#6B7280',
    marginTop: 4,
    textAlign: 'center',
  },
  categoryBreakdown: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 16,
  },
  categoryBreakdownItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
  },
  categoryBreakdownInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  categoryDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginRight: 8,
  },
  categoryBreakdownName: {
    fontSize: 14,
    color: '#374151',
  },
  categoryBreakdownStats: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  categoryBreakdownCount: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  categoryBreakdownPercentage: {
    fontSize: 12,
    color: '#6B7280',
    marginLeft: 4,
  },
  difficultyBreakdown: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  difficultyBreakdownItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
  },
  difficultyBreakdownInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  difficultyDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginRight: 8,
  },
  difficultyBreakdownName: {
    fontSize: 14,
    color: '#374151',
  },
  difficultyBreakdownStats: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  difficultyBreakdownCount: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1F2937',
  },
  difficultyBreakdownPercentage: {
    fontSize: 12,
    color: '#6B7280',
    marginLeft: 4,
  },
  settingsContainer: {
    flex: 1,
    padding: 20,
  },
  settingsSection: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 20,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 3.84,
    elevation: 5,
  },
  settingsSectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1F2937',
    marginBottom: 16,
  },
  settingsItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F3F4F6',
  },
  settingsItemInfo: {
    flex: 1,
  },
  settingsItemTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: '#1F2937',
  },
  settingsItemDescription: {
    fontSize: 14,
    color: '#6B7280',
    marginTop: 2,
  },
  settingsButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#F3F4F6',
  },
  settingsButtonText: {
    marginLeft: 12,
    fontSize: 16,
    color: '#374151',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 60,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#374151',
    marginTop: 16,
    marginBottom: 8,
  },
  emptySubtitle: {
    fontSize: 14,
    color: '#6B7280',
    textAlign: 'center',
    paddingHorizontal: 40,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  questionModal: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    width: width * 0.95,
    maxHeight: height * 0.9,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1F2937',
  },
  modalContent: {
    padding: 20,
    maxHeight: height * 0.6,
  },
  formGroup: {
    marginBottom: 16,
  },
  formRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  formGroupHalf: {
    width: '48%',
  },
  formGroupThird: {
    width: '30%',
  },
  formLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 8,
  },
  formInput: {
    backgroundColor: '#F9FAFB',
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    fontSize: 16,
    color: '#1F2937',
  },
  textArea: {
    height: 100,
    textAlignVertical: 'top',
  },
  pickerContainer: {
    gap: 8,
  },
  pickerOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  pickerOptionSelected: {
    backgroundColor: '#F3E8FF',
    borderColor: '#8B5CF6',
  },
  pickerOptionText: {
    marginLeft: 8,
    fontSize: 14,
    color: '#6B7280',
  },
  pickerOptionTextSelected: {
    color: '#8B5CF6',
    fontWeight: '600',
  },
  optionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  optionRadio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#D1D5DB',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  optionRadioSelected: {
    backgroundColor: '#8B5CF6',
    borderColor: '#8B5CF6',
  },
  optionInput: {
    flex: 1,
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    fontSize: 14,
    color: '#1F2937',
  },
  switchContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  switchLabel: {
    fontSize: 16,
    color: '#374151',
  },
  modalFooter: {
    flexDirection: 'row',
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
  },
  modalCancelButton: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    backgroundColor: '#F3F4F6',
    borderRadius: 12,
    marginRight: 8,
  },
  modalCancelButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#6B7280',
  },
  modalSaveButton: {
    flex: 2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 12,
    backgroundColor: '#8B5CF6',
    borderRadius: 12,
    marginLeft: 8,
  },
  modalSaveButtonText: {
    marginLeft: 8,
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
});

export default TestsBankManagementScreen;